import React, { useState, useContext, useEffect } from 'react';
import { FormItem, Button, FormContext, Icon } from '@digital/ui';
import Upload, { UploadProps } from 'antd/lib/upload';
import { IArquivo, IUploadFile } from '@app/types/core.types';
import { isObjEmpty } from '@app/helpers/objHelper';
import { downloadArquivo } from '@app/api/sas/sasDocumentoOrdemCompra';
import { Visibility } from '../Visibility';

interface IProps {
  fileName?: string;
  accept?: string;
  hasFile?: boolean;
  label?: string;
  hasLabel?: boolean;
  url?: string;
  disabled?: boolean;
  nameFormData?: string;
  type?: "link" | "ghost" | "default" | "primary" | "dashed" | "danger" | undefined;
  className?: string;
  idDoComponente: string;
  showUploadList?: boolean;
  showUpload?: boolean;
  span?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12 | undefined;
  onBeforeUpload?: () => void;
  icon?: React.ComponentProps<typeof Icon>['name'] | 'null';
  onChange?: (info: any) => void;
  onGetArquivo?: () => Promise<IArquivo | undefined>;
  showDownload?: boolean;
  limparCampo?: boolean;
}

export const UploadFile = ({ fileName,
  hasFile = false,
  accept,
  label,
  hasLabel = true,
  url,
  disabled,
  nameFormData,
  type,
  className,
  idDoComponente,
  showUploadList = true,
  showUpload = true,
  span = 12,
  onBeforeUpload,
  icon = 'ui-upload',
  onChange,
  onGetArquivo,
  showDownload = false,
  limparCampo = false
}: IProps) => {

  const [file, setFile] = useState<IUploadFile[]>();
  const [fileTmp, setFileTmp] = useState<IUploadFile>();
  const [disabledItem, setDisabledItem] = useState<boolean>(false);
  const buttonLabel = label ? label : 'Adicionar arquivo';
  const formName = nameFormData ? nameFormData : 'arquivo';

  const { formProps } = useContext(FormContext);

  useEffect(() => {
    setDisabledItem(disabled != undefined && disabled == true ? true : false);
    fileName && setFile([{ uid: '1', name: fileName, url: url } as IUploadFile]);
    let remove = !hasFile;
    if (remove) {
      setFile([]);
      formProps && formProps.setFieldValue(formName, null);
    }
  }, [fileName, hasFile]);

  useEffect(() => {
    setFile([]);
    formProps && formProps.setFieldValue(formName, null);
  }, [limparCampo]);


  useEffect(() => {
    loadArquivos();
  }, []);

  const loadArquivos = async () => {
    onGetArquivo && onGetArquivo()
      .then((arquivo: any) => {

        // console.log('UploadFile', arquivo);
        if (arquivo) {
          const a = {
            uid: arquivo.id,
            name: arquivo.nome,
            status: arquivo.status,
            statusArquivoId: arquivo.statusArquivoId,
            hasActions: false,
          } as IUploadFile;

          setFileTmp(a);
          //vindo da API
          formProps && formProps.setFieldValue(formName + "Api", a);
        }

      });
  };


  const uploadProps: UploadProps = {
    action: '',
    multiple: false,
    type: 'select',
    accept: accept ? accept : '.xlsx, .xls, .png, .doc, .docx, .ppt, .pptx,.txt,.pdf',
    onRemove: _ => {
      setFile([]);
      formProps && formProps.setFieldValue(formName, null);
    },
    beforeUpload: file => {
      setFile([
        {
          uid: '1',
          name: file.name,
        } as IUploadFile,
      ]);
      formProps && formProps.setFieldValue(formName, file);

      onBeforeUpload && onBeforeUpload();
      return false;
    },
    headers: {
      authorization: 'authorization-text',
    },
    showUploadList
  };

  return (
    <>
      <Visibility visible={showUpload}>
        <FormItem name={formName} span={span}>
          <Upload
            id={idDoComponente}
            className={className}
            disabled={disabledItem}
            name={formName}
            {...uploadProps}
            fileList={file}
            onChange={onChange ? onChange : undefined}
          >
            <Button
              id='mrn-button-upload-inserirAnexo'
              type={type ? type : 'link'}
              icon={icon === 'null' ? undefined : icon}>
              {hasLabel && buttonLabel}
            </Button>
          </Upload>
        </FormItem>
      </Visibility>

      {showDownload && fileTmp && (
        <Button
          icon='ui-download'
          type='primary'
          onClick={() => downloadArquivo(fileTmp.uid, fileTmp.name)}
        />
      )}
    </>
  );
};